import { useSelect } from "@wordpress/data";
import DOMPurify from "dompurify";
import { STORE_NAME } from "../store";
import parse from "html-react-parser";

export const VerseAdvancedView = ({
	title,
	permalink,
	sanskrit,
	wordForWord,
	translation,
	commentary,
}) => {
	const verseNum = title.split(".")[1];

	const isSanskritOn = useSelect(
		(select) => select(STORE_NAME).isSanskritOn(),
		[],
	);
	const isWordForWordOn = useSelect(
		(select) => select(STORE_NAME).isWordForWordOn(),
		[],
	);
	const isTranslationOn = useSelect(
		(select) => select(STORE_NAME).isTranslationOn(),
		[],
	);
	const isCommentaryOn = useSelect(
		(select) => select(STORE_NAME).isCommentaryOn(),
		[],
	);
  
	return (
		<div className="bbt-advanced-view">
			<a href={permalink} className="block text-2xl text-center mt-5 mb-2">
				{`${verseNum.includes("-") ? "פסוקים" : "פסוק"} ${verseNum}`}
			</a>
			{isSanskritOn && <div className="text-center">{ parse(DOMPurify.sanitize(sanskrit)) }</div> }
			{isWordForWordOn && (
				<>
					<h4>מילה למילה</h4>
					<div className="text-justify">{parse(DOMPurify.sanitize(wordForWord))}</div>
				</>
			)}
			{isTranslationOn && (
				<>
					<h4>תרגום</h4>
					<div className="font-bold text-justify">{parse(DOMPurify.sanitize(translation))}</div>
				</>
			)}
			{isCommentaryOn && commentary && (
				<>
					<h4>התעמקות</h4>
					<div className="text-justify" > {parse(DOMPurify.sanitize(commentary))} </div>
				</>
			)}
		</div>
	);
};
